import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../../../../const'
import DateAdapter from '../../../../utils/DateAdapter'
import EvaluacionDisciplinaAdministrativa from '../../domain/entities/EvaluacionDisciplinaAdministrativa'

export default class EvaluacionDisciplinaAdministrativaAdapter {
  static toDomain(evaluacionDto) {
    const evaluacion = new EvaluacionDisciplinaAdministrativa(evaluacionDto.fk_idPersonal)
    evaluacion.id = evaluacionDto.id
    evaluacion.idEvaluado = evaluacionDto.fk_idPersonal
    evaluacion.evaluado = evaluacionDto.Personal
    evaluacion.idEvaluador = evaluacionDto.fk_idPersonalEvaluador
    evaluacion.evaluador = evaluacionDto.PersonalEvaluador
    evaluacion.idPeriodicidad = evaluacionDto.fk_idPeriodicidad
    evaluacion.periodicidad = evaluacionDto.CatPeriodicidad?.title || ''
    evaluacion.fechaInicio = new DateAdapter(evaluacionDto.fechaInicial, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.fechaConclusion = new DateAdapter(evaluacionDto.fechaFin, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.fechaAplicacion = new DateAdapter(evaluacionDto.fechaAplicacion, API_DATE_FORMAT).toUiSupportedFormat()
    evaluacion.instanciaInformadora = evaluacionDto.instanciaInforma
    evaluacion.idEstatus = evaluacionDto.fk_idCatEstatusEvaluacion
    evaluacion.estatus = evaluacionDto.CatEstatusEvaluacion?.title || ''
    evaluacion.actas = evaluacionDto.actasAdministrativas || []
    evaluacion.incidencias = evaluacionDto.incidencias.map((incidencia) => ({
      cantidad: incidencia.cantidad,
      idIncidencia: incidencia.fk_idCatIncidencia,
    }))
    evaluacion.reconocimientos = evaluacionDto.reconocimientos
    evaluacion.estimulos = evaluacionDto.estimulos
    evaluacion.actasAdministrativas = evaluacionDto.actasAdministrativas

    return { ...evaluacion }
  }

  static toDto(evaluacion) {
    return {
      id: evaluacion.id,
      fk_idPeriodicidad: evaluacion.idPeriodicidad,
      instanciaInforma: evaluacion.instanciaInformadora,
      fechaInicial: new DateAdapter(evaluacion.fechaInicio, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaFin: new DateAdapter(evaluacion.fechaConclusion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaAplicacion: new DateAdapter(evaluacion.fechaAplicacion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fk_idPersonalEvaluado: evaluacion.idEvaluado,
      fk_idPersonalEvaluador: evaluacion.idEvaluador,
      fk_idCatEstatusEvaluacion: evaluacion.idEstatus,
      incidencias: evaluacion.incidencias.map((incidencia) => ({
        cantidad: incidencia.cantidad,
        fk_idCatIncidencia: incidencia.idIncidencia,
        estatus: true,
      })),
      reconocimientos: evaluacion.reconocimientos.map((reconocimiento) => ({
        ...reconocimiento,
        estatus: true,
      })),
      estimulos: evaluacion.estimulos.map((estimulo) => ({
        ...estimulo,
        estatus: true,
      })),
      actasAdministrativas: evaluacion.actasAdministrativas.map((acta) => ({
        ...acta,
        estatus: true,
      })),
    }
  }
}
